/**
 * The page title. One size, because the design draws one.
 *
 * A page leads with a title and a sentence saying what it currently holds.
 * The kicker above it is contextual, a date or a period, and is never the
 * nav section, which the rail and the trail already say twice over.
 */
import type { ReactNode } from 'react';

import { Inline, Typography } from './finixt.js';

export interface PageHeaderProps {
  title: string;
  subtitle?: ReactNode;
  actions?: ReactNode;
  /** Contextual kicker. Not the nav section. */
  overline?: string | undefined;
}

export function PageHeader({ title, subtitle, actions, overline }: PageHeaderProps) {
  return (
    <header
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'flex-end',
        justifyContent: 'space-between',
        gap: 16,
      }}
    >
      <div style={{ minWidth: 0, flex: '1 1 240px' }}>
        {overline ? (
          <Typography variant="eyebrow" style={{ display: 'block', marginBottom: 7 }}>
            {overline}
          </Typography>
        ) : null}
        <Typography variant="title">{title}</Typography>
        {subtitle ? (
          <Typography
            variant="body-muted"
            as="div"
            style={{ marginTop: 7, maxWidth: '65ch', fontSize: 'var(--text-body-md)' }}
          >
            {subtitle}
          </Typography>
        ) : null}
      </div>
      {actions ? (
        <Inline wrap={false} align="center" style={{ flexShrink: 0 }}>
          {actions}
        </Inline>
      ) : null}
    </header>
  );
}
